var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 86,
    viewBox: "0 0 78 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1477 77.2557C47.1477 77.2557 47.4469 66.6207 47.1477 63.3249C46.8484 60.0292 45.8472 51.6411 45.973 48.1961C46.0988 44.7512 45.2001 42.5043 44.6015 40.5567C44.002 38.6091 42.2045 33.5167 43.4034 23.4803C43.4034 23.4803 43.8528 18.9119 44.1521 17.4883C44.4514 16.0656 44.8558 14.792 45.1407 13.594C45.4256 12.3959 45.5416 7.67745 47.2816 7.37726C49.0207 7.07798 51.5678 6.77779 51.5678 6.77779C51.5678 6.77779 53.066 6.6277 54.9381 9.17478C56.8102 11.721 57.709 12.0211 55.7623 13.3693C53.8146 14.7174 50.3832 11.4972 49.9275 10.9723",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7734 11.2717C46.7734 11.2717 47.3397 12.1309 50.914 11.8883C50.914 11.8883 50.6066 15.166 49.9263 15.3161C49.245 15.4662 47.9724 15.7655 46.7734 15.9902",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3413 6.77611C51.3413 6.77611 51.4159 3.70685 52.6148 3.33297C53.8129 2.95819 54.7116 2.7335 56.36 3.33297C58.0074 3.93244 58.8316 3.92885 59.8804 6.77611C60.9293 9.62427 63.1007 13.6687 59.8804 13.6309C59.8804 13.6309 57.4115 13.7127 56.8516 12.3205",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6377 7.07715C54.6377 7.07715 54.6817 8.85399 55.1796 9.4984",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4736 3.73025C57.4736 3.73025 58.0075 1.2362 59.4311 1.08611C60.8539 0.936015 62.1274 0.721212 63.6256 2.96271C64.5936 4.41241 65.0618 5.08108 65.3926 5.87918C65.5732 6.31508 65.7134 6.79052 65.8725 7.45201C66.3219 9.32412 67.5954 13.5186 64.1496 14.0426C64.1496 14.0426 61.8173 14.4893 61.5603 11.8694",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0394 11.2718C71.0394 11.2718 71.8635 7.30201 71.0394 5.57999C70.2152 3.85707 68.5678 3.78247 67.145 3.78247C65.7223 3.78247 65.4365 5.68244 65.778 7.07821",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3354 21.7575C74.3354 21.7575 72.4633 23.405 71.1151 21.7575C69.767 20.1101 68.5609 19.0613 68.5276 16.5897C68.4944 14.1181 68.3362 12.193 69.767 11.2717C71.1978 10.3514 72.9126 14.7922 73.5867 15.4662C74.2608 16.1403 75.0849 16.889 75.8336 17.563C76.5823 18.2371 77.1817 19.286 77.1071 22.881C77.0326 26.476 77.1134 30.595 77.1134 30.595C77.1134 30.595 77.1071 32.3179 74.6356 34.1901C72.164 36.0622 67.4455 40.7061 67.4455 40.7061C67.4455 40.7061 64.4499 43.2522 64.6746 48.1208C64.8993 52.9894 65.124 59.58 65.4233 63.0249C65.7226 66.4698 68.3443 81 68.3443 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3975 11.8865C66.3975 11.8865 67.3394 13.4557 68.7774 12.5884",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.301 20.7869C70.301 20.7869 69.5622 24.7531 70.301 25.5763C71.0398 26.3996 72.1632 26.5497 72.1632 26.5497",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0898 59.4258C37.0898 62.2253 36.5951 64.6797 35.6055 66.7891C34.6159 68.8984 33.1966 70.526 31.3477 71.6719C29.5117 72.8177 27.4023 73.3906 25.0195 73.3906C22.6628 73.3906 20.5599 72.8242 18.7109 71.6914C16.862 70.5586 15.4297 68.944 14.4141 66.8477C13.3984 64.7383 12.8841 62.3164 12.8711 59.582V58.1758C12.8711 55.3763 13.3724 52.9154 14.375 50.793C15.3906 48.6576 16.8164 47.0234 18.6523 45.8906C20.5013 44.7448 22.6107 44.1719 24.9805 44.1719C27.3503 44.1719 29.4531 44.7448 31.2891 45.8906C33.138 47.0234 34.5638 48.6576 35.5664 50.793C36.582 52.9154 37.0898 55.3698 37.0898 58.1562V59.4258ZM31.1523 58.1367C31.1523 55.1549 30.6185 52.8893 29.5508 51.3398C28.4831 49.7904 26.9596 49.0156 24.9805 49.0156C23.0143 49.0156 21.4974 49.7839 20.4297 51.3203C19.362 52.8438 18.8216 55.0833 18.8086 58.0391V59.4258C18.8086 62.3294 19.3424 64.582 20.4102 66.1836C21.4779 67.7852 23.0143 68.5859 25.0195 68.5859C26.9857 68.5859 28.4961 67.8177 29.5508 66.2812C30.6055 64.7318 31.1393 62.4792 31.1523 59.5234V58.1367Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 61.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhand);
export default __webpack_public_path__ + "static/media/Ohand.773b5484ff25dea06a562d76af10de1f.svg";
export { ForwardRef as ReactComponent };